import { createStore, applyMiddleware } from 'redux';
import { createRootReducer } from '../reducers/index';
import { uiStateToToolStateMapper } from '../middlewares/uiStateToToolMapper';

const configureStore = () => {
  return createStore(
    createRootReducer(),
    applyMiddleware(uiStateToToolStateMapper),
  );
};

export default configureStore;
